import FullScreenChartModal from './FullScreenChartModal';

export default FullScreenChartModal;
